module.exports = __webpack_public_path__ + "static/img/4.a4a7691.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/4.png
// module id = wHdo
// module chunks = 37